
<template>
<!-- 此组件目前仅用于佣金查询，如用于其他列表，需优化该组件使用模板语法 -->
  <div class="container">
    <van-steps direction="vertical">
      <van-step v-for="(item, index) in list" :key="index">
        <div class="step">
          <h3>{{ item.year + `年 ` + item.month + `月` }}</h3>
          <div class="buttom" @click="clickButtom(item)">交易明细</div>
          <p>实发金额： ￥{{ item.actPayAmount }}</p>
        </div>
      </van-step>
    </van-steps>
  </div>
</template>

<script>

export default {
  components: {
  },
  props:{
    list:[]
  },
  data() {
    return {
      active: 0,
    };
  },
  methods: {
    // 交易明细按钮
    clickButtom(obj){
      this.$router.push({
        path:'/home/IncomeDetai/DealDetai',
        name: 'DealDetai',
        query: { c: obj.stmBatchEmployeeItemId, ts: obj.projectPayrollType},
      });
    }
  },
};
</script>

<style lang='less'>
.step {
  background: #008c8c;
  width: 100%;
  padding: 0 8px;
  box-sizing: border-box;
  height: auto;
  color: #fff;
  border-radius: 5px;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  h3 {
    padding: 10px;
  }
  .buttom{
    position: absolute;
    right: 20px;
    top: 28px;
    border: #fff 1px solid;
    padding: 5px;
    border-radius: 5px;
  }
  p {
    padding-left: 10px;
    padding-bottom: 10px
  }
}
</style>